import { AuxiliumComponent } from "../auxilium-component";

export class ListItem extends AuxiliumComponent {
	static observedAttributes = ["hide"];

	constructor() {
		super();

		this.hide = this.hasAttribute("hide");
	}

	parsedCallback() {
		if (this.closest("chip-list")?.hasAttribute("clickable")) {
			this.appendChild(document.createElementWithContents("chip-button", this.childNodes, {
				variation: "body",
				className: "list--button"
			}));
		}
	}
}